import React from 'react'
import  ThanksImage from '../../assets/images/icon-thank-you.svg'
import './ThankYou.css'

const ThankYou = () => {
  return (
    <div className='ThankYou'>
      <img src={ThanksImage} alt="Thank You" />
        <h1>Thank You!</h1>
        <p>Thanks for confirming your subscription! We hope you have fun using our platform. If you ever need support, please feel free to email us at support@example.com</p>
    </div>
  )
}

export default ThankYou
